<template>
  <div class="SCRUMTable">
    <v-container grid-list-md fluid fill-height>
      <v-layout row wrap justify-center>
      <v-flex xs12>
        <v-card>
          <v-expansion-panel
            v-model="panel"
            expand
            popout
          >
            <v-expansion-panel-content>
              <template v-slot:header>
                <v-card-title class="title">
                  Aplicar Filtros
                </v-card-title>
              </template>
              <v-card>
                <v-card-text>
                  <!--Fecha fitiros -->
                  <v-layout wrap justify-space-between>
                    <v-flex xs12 md3>
                      <v-menu
                        :close-on-content-click="false"
                        v-model="menuIni"
                        transition="scale-transition"
                        offset-y
                        full-width
                        :nudge-right="40"
                        max-width="290px"
                        min-width="290px"
                        :disabled="loadingFuida"
                      >
                        <v-text-field
                          slot="activator"
                          label="Fecha Inicial"
                          v-model="dateIni"
                          prepend-icon="event"
                          readonly
                          hint="Debe ser anterior a la fecha final"
                          persistent-hint
                        ></v-text-field>
                        <v-date-picker
                          v-model="dateIni"
                          locale="es-CO"
                          no-title
                          scrollable
                          actions
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs12 md3>
                      <v-menu
                        :close-on-content-click="false"
                        v-model="menuEnd"
                        transition="scale-transition"
                        offset-y
                        full-width
                        :nudge-right="40"
                        max-width="290px"
                        min-width="290px"
                        :disabled="loadingFuida"
                      >
                        <v-text-field
                          slot="activator"
                          label="Fecha Final"
                          v-model="dateEnd"
                          prepend-icon="event"
                          readonly
                          hint="Debe ser posterior a la fecha inicial"
                          persistent-hint
                        ></v-text-field>
                        <v-date-picker
                          v-model="dateEnd"
                          locale="es-CO"
                          no-title
                          scrollable
                          actions
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-spacer/>
                  </v-layout>
                    <!--Encuestador fitiros -->
                    <v-layout wrap justify-space-between>
                      <v-flex xs12 md3>
                        <v-select
                          :items="items"
                          label="Área"
                          v-model="area"
                          type="selected"
                          prepend-icon="person"
                          :disabled="loadingFuida"
                        ></v-select>
                      </v-flex>
                      <v-spacer/>
                      <!--codigo fitiros -->
                        <v-flex xs12 md3>
                          <v-select
                           :items="items1"
                            label="Responsable"
                            v-model="rpb"
                            type="selected"
                            prepend-icon="person"
                            :disabled="loadingFuida"
                          ></v-select>
                        </v-flex>
                        <v-spacer/>
                    </v-layout>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="warning"
              :disabled="loadingFuida"
              @click="clear()"
            >
              Limpiar
            </v-btn>

            <v-btn
              color="info"
              :disabled="loadingFuida || loadingTable || vDate"
              @click="loadData()"
            >
              <v-icon left>cloud_download</v-icon> {{ btnText }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
        <v-flex md10>
          <v-card class="mb-2">
            <v-card-title class="title">
              Dedicación a proyectos
              <v-spacer/>

              <v-card-actions>
                <v-btn color="info" :disabled="dataVals === null">
                  <download-csv
                    :data="dataVals"
                    name="ReporteProyecto.csv"
                    :labels="labels"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-text
              v-if="loadingFuida"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <data-table
                :headers="headers"
                :dataVals="dataVals"
                :items="dataVals"
                :searchActive="true"
                :key="tableKey"
              />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import dataTable from '@/components/Tables/TableBase'
import JsonCSV from 'vue-json-csv'
import moment from 'moment'

export default {
  name: 'SCRUMTable',

  components: {
    'data-table': dataTable,
    'download-csv': JsonCSV
  },

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
  },

  data: function () {
    return {
      backConf: {
        path: '/projects/scrum_proyecto/',
        page: 1
      },

      loadingFuida: false,
      loadingTable: false,
      progressSize: 70,
      progressWidth: 7,

      operativo: null,

      panel: [false],

      dateIni: null,
      dateEnd: null,
      area: null,
      rpb: null,
      filter: [],

      arreglo: [],

      filterBy: null,

      items: ['GERENCIA','DIRECCION NACIONAL DE CAMPO','DIRECCION DE ANALITICA','DIRECCION ADMINISTRATIVA',
              'DIRECCION FINANCIERA','DIRECCION DE PROYECTOS Y GESTION DE NEGOCIOS','DIRECCION DE TIC'],

      items1:['ADRIANA PEDROZA',
      'ALEJANDRO ARANGUREN',
      'ALEJANDRO BARAJAS',
      'ALEXANDRA GUZMÁN',
      'ALEXANDRA ORTEGON',
      'ALEXIS MALUENDAS',
      'ANA MARIA RUIZ',
      'ANDERSON OSORIO',
      'ANDRES GUZMAN',
      'ARNULFO ARIAS',
      'BEATRIZ SUAREZ',
      'CAMILO PINILLA',
      'CAROL MARTINEZ',
      'CLAUDIA MORALES',
      'CRISTIAN MORA',
      'DANIELA FERRO',
      'DANIELA LOPEZ',
      'DANY BERMUDEZ',
      'DAVID ANTIA',
      'DENIS LOPEZ',
      'DIEGO SANTOS',
      'EDISON BUITRAGO',
      'ERICK FONSECA',
      'FERNANDO ALVEAR',
      'FRED MURILLO',
      'GABRIELA ORDOÑEZ',
      'GERMAN GARCIA',
      'GINNA FONSECA',
      'GUILLERMO GALATRO',
      'GUSTAVO DIAZ',
      'IVAN RIVERA',
      'IVAN ROMERO',
      'JAIRO ARDILA',
      'JAIRO ARDILA',
      'JAVIER ACOSTA',
      'JHOSMAN LIZARAZO',
      'JOHAN MORA',
      'JOHN CASTELLANOS',
      'JOHN LORENZANA',
      'JOHN SANCHEZ',
      'JORGE TORRES',
      'JUAN DAVID MENDEZ',
      'JULIAN ROLON',
      'JULIETH LOPEZ',
      'JULIO CASTILLO',
      'KAREN COBA',
      'KELLY ARIZA',
      'LAURA ARMENTA',
      'LUZ HERRERA',
      'LUZ MELLO',
      'LUZ PASCAGAZA',
      'MANUEL MONTALVO',
      'MARGARITA PULIDO',
      'MARTHA BARRERA',
      'MARTHA MARTINEZ',
      'MARTHA SANDOVAL',
      'MICHEL BARROS',
      'NAHUM DE AVILA',
      'NESTOR MANOSALVA',
      'OSCAR SALAZAR',
      'OSMAR CASTILLO',
      'PAULA ALTAMAR',
      'RICARDO CANO C',
      'RUTH ORJUELA',
      'SALOME JACOME',
      'SHERLY CASTRO',
      'SHIRLY ARIAS',
      'STELLA JAIMES',
      'WILLIAM DUARTE',
      'WILLIAM NIÑO',
      'YUBELY MUÑOZ',
      'YUDY MORON'],

      headers: [
       { text: 'Fecha', align: 'start', sortable: false, value: 'fecha_end__date' },
       { text: 'Responsable', value: 'data__p2' },
       { text: 'Area', value: 'data__p3' },
       { text: 'Proyecto 1', value: 'data__p4' },
       { text: 'Proyecto 2', value: 'data__p14' },
       { text: 'Proyecto 3', value: 'data__p24' },
       { text: 'Proyecto 4', value: 'data__p34' },
       { text: 'Proyecto 5', value: 'data__p44' },
       { text: 'Proyecto 6', value: 'data__p54' },
       { text: 'Proyecto 7', value: 'data__p64' },
       { text: 'Proyecto 8', value: 'data__p74' },
       { text: 'Proyecto 9', value: 'data__p84' },
       { text: 'Proyecto 10', value: 'data__p94' },
     ],

      dataVals: null,
      tableKey: 0
    }
  },
  computed: {
    /**
     * Verifica que la fecha final no sea anterior a la fecha inicial
     * @return {string} validación de las fechas
     */
    vDate: function vDate () {
      if (this.dateIni && this.dateEnd) {
        return moment(this.dateEnd).isBefore(this.dateIni)
      }
      return false
    },

    /**
     * Determina el texto que tendra el boton
     * @return {boolean} Texto poara poner en el boton
     */
    btnText: function btnText () {
      if (!this.dateIni && !this.dateEnd && !this.area && !this.rpb) {
        return 'Consultar/Generar'
      }
      return 'Cargar con Filtro'
    },

    /**
     * Genera el objeto para realizar la consulta
     * @return {Object} Objeto de la forma id[field]:id[choice]
     */
    filterToApply: function filterToApply () {
      if (this.filter.length < 1) {
        return null
      }

      let obj = {}

      this.filterBy.forEach(function (filt, index) {
        obj[filt.id] = this.filter[index]
      }, this)
      return obj
    }
  },

  methods: {
    /** Carga la tabla
     */
    loadTable () {
      this.arreglo = null
      this.loadingFuida = true
      this.dataVals = null
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          fechainicio: this.dateIni,
          fechafin: this.dateEnd,
          area: this.area,
          rpb: this.rpb,
          filtro: this.filterToApply
        }
      }

      let t = this

      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.arreglo = resp.data[0].tes
          t.loadingFuida = false
          t.tableKey += 1
          let cant = [] // datos para tabla
          if (t.arreglo.length > 0) {
            t.arreglo.forEach(function (element) {
              if (element['Imagen'] == null) {
                element['Imagen'] = 'No disponible'
              }
              cant.push(element)
            })
          }
          t.dataVals = cant
        })
        .catch(function (err) {
          console.error(err)
          t.dataVals = []
          t.loadingFuida = false
        })
    },
    loadFiltro () {
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          operativo: this.operativo,
          tipo: 'filtro'
        }
      }
      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.filterBy = resp.data
        })
        .catch(function (err) {
          t.filterBy = null
          console.error(err)
        })
    },
    loadData () {
      this.loadTable()
      this.panel = [false]
    },
    clear () {
      this.dateIni = null
      this.dateEnd = null
      this.area = null
      this.rpb = null
      this.filter = []
    }
  }
}
</script>
